export interface CountryCode {
  name: string,
  isoAlpha2: string,
  value?: string
}
/**
 * ISO Country code list created from https://wikipedia.org/wiki/ISO_3166-1_alfa-3
 * In order to match BE values on:
 * https://bitbucket.org/exporodev/exporo_ident/src/master/application/config/enums.php
 *
*/
export const countryCodesEnum = Object.assign({
  ABW: { name: 'Aruba', isoAlpha2: 'AW' },
  AFG: { name: 'Afghanistan', isoAlpha2: 'AF' },
  AGO: { name: 'Angola', isoAlpha2: 'AO' },
  AIA: { name: 'Anguilla', isoAlpha2: 'AI' },
  ALA: { name: 'Åland Islands', isoAlpha2: 'AL' },
  ALB: { name: 'Albania', isoAlpha2: 'ALB' },
  AND: { name: 'Andorra', isoAlpha2: 'AD' },
  ANT: { name: 'Netherlands Antilles', isoAlpha2: 'AN' },
  ARE: { name: 'United Arab Emirates', isoAlpha2: 'AE' },
  ARG: { name: 'Argentina', isoAlpha2: 'AR' },
  ARM: { name: 'Armenia', isoAlpha2: 'AM' },
  ASM: { name: 'American Samoa', isoAlpha2: 'AS' },
  ATA: { name: 'Antárctica', isoAlpha2: 'AQ' },
  ATF: { name: 'French Southern Territories', isoAlpha2: 'TF' },
  ATG: { name: 'Antigua and Barbuda', isoAlpha2: 'AG' },
  AUS: { name: 'Australia', isoAlpha2: 'AU' },
  AUT: { name: 'Austria', isoAlpha2: 'AT' },
  AZE: { name: 'Azerbaijan', isoAlpha2: 'AZ' },
  BDI: { name: 'Burundi', isoAlpha2: 'BI' },
  BEL: { name: 'Belgium', isoAlpha2: 'BE' },
  BEN: { name: 'Benin', isoAlpha2: 'BJ' },
  BFA: { name: 'Burkina Faso', isoAlpha2: 'BF' },
  BGD: { name: 'Bangladesh', isoAlpha2: 'BD' },
  BGR: { name: 'Bulgaria', isoAlpha2: 'BG' },
  BHR: { name: 'Bahrain', isoAlpha2: 'BH' },
  BHS: { name: 'Bahamas', isoAlpha2: 'BS' },
  BIH: { name: 'Bosnia and Herzegovina', isoAlpha2: 'BA' },
  BLR: { name: 'Belarus', isoAlpha2: 'BY' },
  BLZ: { name: 'Belize', isoAlpha2: 'BZ' },
  BMU: { name: 'Bermuda', isoAlpha2: 'BM' },
  BOL: { name: 'Bolivia', isoAlpha2: 'BO' },
  BRA: { name: 'Brazil', isoAlpha2: 'BR' },
  BRB: { name: 'Barbados', isoAlpha2: 'BB' },
  BRN: { name: 'Brunei Darussalam', isoAlpha2: 'BN' },
  BTN: { name: 'Bhutan', isoAlpha2: 'BT' },
  BVT: { name: 'Bouvet Island', isoAlpha2: 'BV' },
  BWA: { name: 'Botswana', isoAlpha2: 'BW' },
  CAF: { name: 'Central African Republic', isoAlpha2: 'CF' },
  CAN: { name: 'Canada', isoAlpha2: 'CA' },
  CCK: { name: 'Cocos (Keeling) Islands', isoAlpha2: 'CC' },
  CHE: { name: 'Switzerland', isoAlpha2: 'CH' },
  CHL: { name: 'Chile', isoAlpha2: 'CL' },
  CHN: { name: 'China', isoAlpha2: 'CN' },
  CIV: {
    name: 'Côte d\'Ivoire', isoAlpha2: 'CI',
  },
  CMR: { name: 'Cameroon', isoAlpha2: 'CM' },
  COD: { name: 'Congo, Democratic Republic of the', isoAlpha2: 'CD' },
  COG: { name: 'Congo, Republic of the', isoAlpha2: 'CG' },
  COK: { name: 'Cook Islands', isoAlpha2: 'CK' },
  COL: { name: 'Colombia', isoAlpha2: 'CO' },
  COM: { name: 'Comoros', isoAlpha2: 'KM' },
  CPV: { name: 'Cape Verde', isoAlpha2: 'CV' },
  CRI: { name: 'Costa Rica', isoAlpha2: 'CR' },
  CUB: { name: 'Cuba', isoAlpha2: 'CU' },
  CXR: { name: 'Christmas Island', isoAlpha2: 'CX' },
  CYM: { name: 'Cayman Islands', isoAlpha2: 'KY' },
  CYP: { name: 'Cyprus', isoAlpha2: 'CY' },
  CZE: { name: 'Czechia', isoAlpha2: 'CZ' },
  DEU: { name: 'Germany', isoAlpha2: 'DE' },
  DJI: { name: 'Djibouti', isoAlpha2: 'DJ' },
  DMA: { name: 'Dominica', isoAlpha2: 'DM' },
  DNK: { name: 'Denmark', isoAlpha2: 'DK' },
  DOM: { name: 'Dominican Republic', isoAlpha2: 'DO' },
  DZA: { name: 'Algeria', isoAlpha2: 'DZ' },
  ECU: { name: 'Ecuador', isoAlpha2: 'EC' },
  EGY: { name: 'Egypt', isoAlpha2: 'EG' },
  ERI: { name: 'Eritrea', isoAlpha2: 'ER' },
  ESH: { name: 'Western Sahara', isoAlpha2: 'EH' },
  ESP: { name: 'Spain', isoAlpha2: 'ES' },
  EST: { name: 'Estonia', isoAlpha2: 'EE' },
  ETH: { name: 'Ethiopia', isoAlpha2: 'ET' },
  FIN: { name: 'Finland', isoAlpha2: 'FI' },
  FJI: { name: 'Fiji', isoAlpha2: 'FJ' },
  FLK: {
    name: 'Falkland Islands(Malvinas)', isoAlpha2: 'FK',
  },
  FRA: { name: 'France', isoAlpha2: 'FR' },
  FRO: { name: 'Faroe Islands', isoAlpha2: 'FO' },
  FSM: { name: 'Micronesia Federated States of', isoAlpha2: 'FM' },
  GAB: { name: 'Gabon', isoAlpha2: 'GA' },
  GBR: { name: 'United Kingdom', isoAlpha2: 'GB' },
  GEO: { name: 'Georgia', isoAlpha2: 'GE' },
  GGY: { name: 'Guernsey', isoAlpha2: 'GG' },
  GHA: { name: 'Ghana', isoAlpha2: 'GH' },
  GIB: { name: 'Gibraltar', isoAlpha2: 'GI' },
  GIN: { name: 'Guinea', isoAlpha2: 'GN' },
  GLP: { name: 'Guadeloupe', isoAlpha2: 'GP' },
  GMB: { name: 'Gambia', isoAlpha2: 'GM' },
  GNB: { name: 'Guinea - Bissau', isoAlpha2: 'GW' },
  GNQ: { name: 'Equatorial Guinea', isoAlpha2: 'GQ' },
  GRC: { name: 'Greece', isoAlpha2: 'GR' },
  GRD: { name: 'Grenada', isoAlpha2: 'GD' },
  GRL: { name: 'Greenland', isoAlpha2: 'GL' },
  GTM: { name: 'Guatemala', isoAlpha2: 'GT' },
  GUF: { name: 'French Guiana', isoAlpha2: 'GF' },
  GUM: { name: 'Guam', isoAlpha2: 'GU' },
  GUY: { name: 'Guyana', isoAlpha2: 'GY' },
  HKG: { name: 'Hong Kong', isoAlpha2: 'HK' },
  HMD: { name: 'Heard Island and McDonald Islands', isoAlpha2: 'HM' },
  HND: { name: 'Honduras', isoAlpha2: 'HN' },
  HRV: { name: 'Croatia', isoAlpha2: 'HR' },
  HTI: { name: 'Haiti', isoAlpha2: 'HT' },
  HUN: { name: 'Hungary', isoAlpha2: 'HU' },
  IDN: { name: 'Indonesia', isoAlpha2: 'ID' },
  IMN: { name: 'Isle of Man', isoAlpha2: 'IM' },
  IND: { name: 'India', isoAlpha2: 'IN' },
  IOT: { name: 'British Indian Ocean Territory', isoAlpha2: 'IO' },
  IRL: { name: 'Ireland', isoAlpha2: 'IE' },
  IRN: { name: 'Iran, Islamic Republic of', isoAlpha2: 'IR' },
  IRQ: { name: 'Iraq', isoAlpha2: 'IQ' },
  ISL: { name: 'Iceland', isoAlpha2: 'IS' },
  ISR: { name: 'Israel', isoAlpha2: 'IL' },
  ITA: { name: 'Italy', isoAlpha2: 'IT' },
  JAM: { name: 'Jamaica', isoAlpha2: 'JM' },
  JEY: { name: 'Jersey', isoAlpha2: 'JE' },
  JOR: { name: 'Jordan', isoAlpha2: 'JO' },
  JPN: { name: 'Japan', isoAlpha2: 'JP' },
  KAZ: { name: 'Kazakhstan', isoAlpha2: 'KZ' },
  KEN: { name: 'Kenya', isoAlpha2: 'KE' },
  KGZ: { name: 'Kyrgyzstan', isoAlpha2: 'KG' },
  KHM: { name: 'Cambodia', isoAlpha2: 'KH' },
  KIR: { name: 'Kiribati', isoAlpha2: 'KI' },
  KNA: { name: 'Saint Kitts and Nevis', isoAlpha2: 'KN' },
  KOR: { name: 'Korea, Republic of', isoAlpha2: 'KR' },
  KWT: { name: 'Kuwait', isoAlpha2: 'KW' },
  LAO: {
    name: 'Lao People\'s Democratic Republic', isoAlpha2: 'LA',
  },
  LBN: { name: 'Lebanon', isoAlpha2: 'LB' },
  LBR: { name: 'Liberia', isoAlpha2: 'LR' },
  LBY: { name: 'Libyan Arab Jamahiriya', isoAlpha2: 'LY' },
  LCA: { name: 'Saint Lucia', isoAlpha2: 'LC' },
  LIE: { name: 'Liechtenstein', isoAlpha2: 'LI' },
  LKA: { name: 'Sri Lanka', isoAlpha2: 'LK' },
  LSO: { name: 'Lesotho', isoAlpha2: 'LS' },
  LTU: { name: 'Lithuania', isoAlpha2: 'LT' },
  LUX: { name: 'Luxembourg', isoAlpha2: 'LU' },
  LVA: { name: 'Latvia', isoAlpha2: 'LV' },
  MAC: { name: 'Macao', isoAlpha2: 'MO' },
  MAR: { name: 'Morocco', isoAlpha2: 'MA' },
  MCO: { name: 'Monaco', isoAlpha2: 'MC' },
  MDA: { name: 'Moldova, Republic of', isoAlpha2: 'MD' },
  MDG: { name: 'Madagascar', isoAlpha2: 'MG' },
  MDV: { name: 'Maldives', isoAlpha2: 'MV' },
  MEX: { name: 'Mexico', isoAlpha2: 'MX' },
  MHL: { name: 'Marshall Islands', isoAlpha2: 'MH' },
  MKD: { name: 'Macedonia the former Yugoslav, Republic of', isoAlpha2: 'MK' },
  MLI: { name: 'Mali', isoAlpha2: 'ML' },
  MLT: { name: 'Malta', isoAlpha2: 'MT' },
  MMR: { name: 'Myanmar', isoAlpha2: 'MM' },
  MNE: { name: 'Montenegro', isoAlpha2: 'ME' },
  MNG: { name: 'Mongolia', isoAlpha2: 'MN' },
  MNP: { name: 'Northern Mariana Islands', isoAlpha2: 'MP' },
  MOZ: { name: 'Mozambique', isoAlpha2: 'MZ' },
  MRT: { name: 'Mauritania', isoAlpha2: 'MR' },
  MSR: { name: 'Montserrat', isoAlpha2: 'MS' },
  MTQ: { name: 'Martinique', isoAlpha2: 'MQ' },
  MUS: { name: 'Mauritius', isoAlpha2: 'MU' },
  MWI: { name: 'Malawi', isoAlpha2: 'MW' },
  MYS: { name: 'Malaysia', isoAlpha2: 'MY' },
  MYT: { name: 'Mayotte', isoAlpha2: 'YT' },
  NAM: { name: 'Namibia', isoAlpha2: 'NA' },
  NCL: { name: 'New Caledonia', isoAlpha2: 'NC' },
  NER: { name: 'Niger', isoAlpha2: 'NE' },
  NFK: { name: 'Norfolk Island', isoAlpha2: 'NF' },
  NGA: { name: 'Nigeria', isoAlpha2: 'NG' },
  NIC: { name: 'Nicaragua', isoAlpha2: 'NI' },
  NIU: { name: 'Niue', isoAlpha2: 'NU' },
  NLD: { name: 'Netherlands', isoAlpha2: 'NL' },
  NOR: { name: 'Norway', isoAlpha2: 'NO' },
  NPL: { name: 'Nepal', isoAlpha2: 'NP' },
  NRU: { name: 'Nauru', isoAlpha2: 'NR' },
  NZL: { name: 'New Zealand', isoAlpha2: 'NZ' },
  OMN: { name: 'Oman', isoAlpha2: 'OM' },
  PAK: { name: 'Pakistan', isoAlpha2: 'PK' },
  PAN: { name: 'Panama', isoAlpha2: 'PA' },
  PCN: { name: 'Pitcairn', isoAlpha2: 'PN' },
  PER: { name: 'Peru', isoAlpha2: 'PE' },
  PHL: { name: 'Philippines', isoAlpha2: 'PH' },
  PLW: { name: 'Palau', isoAlpha2: 'PW' },
  PNG: { name: 'Papua New Guinea', isoAlpha2: 'PG' },
  POL: { name: 'Poland', isoAlpha2: 'PL' },
  PRI: { name: 'Puerto Rico', isoAlpha2: 'PR' },
  PRK: {
    name: 'Korea, Democratic People\'s Republic of', isoAlpha2: 'KP',
  },
  PRT: { name: 'Portugal', isoAlpha2: 'PT' },
  PRY: { name: 'Paraguay', isoAlpha2: 'PY' },
  PSE: { name: 'Palestinian Territory Occupied', isoAlpha2: 'PS' },
  PYF: { name: 'French Polynesia', isoAlpha2: 'PF' },
  QAT: { name: 'Qatar', isoAlpha2: 'QA' },
  REU: { name: 'Réunion', isoAlpha2: 'RE' },
  ROU: { name: 'Romania', isoAlpha2: 'RO' },
  RUS: { name: 'Russia', isoAlpha2: 'RU' },
  RWA: { name: 'Rwanda', isoAlpha2: 'RW' },
  SAU: { name: 'Saudi Arabia', isoAlpha2: 'SA' },
  SDN: { name: 'Sudan', isoAlpha2: 'SD' },
  SEN: { name: 'Senegal', isoAlpha2: 'SN' },
  SGP: { name: 'Singapore', isoAlpha2: 'SG' },
  SGS: { name: 'South Georgia and the South Sandwich Islands', isoAlpha2: 'GS' },
  SHN: { name: 'Saint Helena', isoAlpha2: 'SH' },
  SJM: { name: 'Svalbard and Jan Mayen', isoAlpha2: 'SJ' },
  SLB: { name: 'Solomon Islands', isoAlpha2: 'SB' },
  SLE: { name: 'Sierra Leone', isoAlpha2: 'SL' },
  SLV: { name: 'El Salvador', isoAlpha2: 'SV' },
  SMR: { name: 'San Marino', isoAlpha2: 'SM' },
  SOM: { name: 'Somalia', isoAlpha2: 'SO' },
  SPM: { name: 'Saint Pierre and Miquelon', isoAlpha2: 'PM' },
  SRB: { name: 'Serbia', isoAlpha2: 'RS' },
  STP: { name: 'Sao Tome and Principe', isoAlpha2: 'ST' },
  SUR: { name: 'Suriname', isoAlpha2: 'SR' },
  SVK: { name: 'Slovakia', isoAlpha2: 'SK' },
  SVN: { name: 'Slovenia', isoAlpha2: 'SI' },
  SWE: { name: 'Sweden', isoAlpha2: 'SE' },
  SWZ: { name: 'Swaziland', isoAlpha2: 'SZ' },
  SYC: { name: 'Seychelles', isoAlpha2: 'SC' },
  SYR: { name: 'Syrian Arab Republic', isoAlpha2: 'SY' },
  TCA: { name: 'Turks and Caicos Islands', isoAlpha2: 'TC' },
  TCD: { name: 'Chad', isoAlpha2: 'TD' },
  TGO: { name: 'Togo', isoAlpha2: 'TG' },
  THA: { name: 'Thailand', isoAlpha2: 'TH' },
  TJK: { name: 'Tajikistan', isoAlpha2: 'TJ' },
  TKL: { name: 'Tokelau', isoAlpha2: 'TK' },
  TKM: { name: 'Turkmenistan', isoAlpha2: 'TM' },
  TLS: { name: 'Timor - Leste', isoAlpha2: 'TL' },
  TON: { name: 'Tonga', isoAlpha2: 'TO' },
  TTO: { name: 'Trinidad and Tobago', isoAlpha2: 'TT' },
  TUN: { name: 'Tunisia', isoAlpha2: 'TN' },
  TUR: { name: 'Turkey', isoAlpha2: 'TR' },
  TUV: { name: 'Tuvalu', isoAlpha2: 'TV' },
  TWN: { name: 'Taiwan Province of China', isoAlpha2: 'TW' },
  TZA: { name: 'Tanzania, United Republic of', isoAlpha2: 'TZ' },
  UGA: { name: 'Uganda', isoAlpha2: 'UG' },
  UKR: { name: 'Ukraine', isoAlpha2: 'UA' },
  UMI: { name: 'United States Minor Outlying Islands', isoAlpha2: 'UM' },
  URY: { name: 'Uruguay', isoAlpha2: 'UY' },
  USA: { name: 'United States', isoAlpha2: 'US' },
  UZB: { name: 'Uzbekistan', isoAlpha2: 'UZ' },
  VAT: {
    name: 'Holy See(Vatican City State) ', isoAlpha2: 'VA',
  },
  VCT: { name: 'Saint Vincent and the Grenadines', isoAlpha2: 'VC' },
  VEN: { name: 'Venezuela', isoAlpha2: 'VE' },
  VGB: { name: 'Virgin Islands British', isoAlpha2: 'VG' },
  VIR: {
    name: 'Virgin Islands U.S.', isoAlpha2: 'VI',
  },
  VNM: { name: 'Viet Nam', isoAlpha2: 'VN' },
  VUT: { name: 'Vanuatu', isoAlpha2: 'VU' },
  WLF: { name: 'Wallis and Futuna', isoAlpha2: 'WF' },
  WSM: { name: 'Samoa', isoAlpha2: 'WS' },
  YEM: { name: 'Yemen', isoAlpha2: 'YE' },
  ZAF: { name: 'South Africa', isoAlpha2: 'ZA' },
  ZMB: { name: 'Zambia', isoAlpha2: 'ZM' },
  ZWE: { name: 'Zimbabwe', isoAlpha2: 'ZW' },
});

Object.freeze(countryCodesEnum);

function getEnumAsArray() {
  return Object.keys(countryCodesEnum)
    .map(key => ({
      name: countryCodesEnum[key].name,
      value: key,
      isoAlpha2: countryCodesEnum[key].isoAlpha2,
    }));
}

export const countryCodesArray: Array<CountryCode> = getEnumAsArray();

export default {
  countryCodesEnum,
};
